<template>
  <div>
    <div class="card printhide">
      <div class="content inset"
        v-if="
          intakeAdmin.beleggen.brand === 'Doelbeleggen' || intakeAdmin.beleggen.brand === 'OXBY'
        ">
        <button
          class="secondary setting"
          @click="$parent.returnIntake"
          v-if="$parent.status == 'Ingeleverd' && $parent.role > 7"
        >
          <awesomeIcon icon="edit" /> Heropenen (admin)
        </button>
        <button
          class="secondary setting"
          @click="$parent.overviewToggle = true"
          v-if="$parent.role > 7"
        >
          <awesomeIcon icon="sign-out-alt" /> Overzicht bekijken (admin)
        </button>
        <h2 class="title">
          <awesomeIcon icon="lock" />
          {{ $parent.redo ? 'Vragenlijst ontvangen' : 'Rekening geopend'}}
        </h2>
        <template v-if="$parent.redo">
          <h2>Wij hebben uw wijzigingen ontvangen</h2>
          <p v-if="
            $parent.intake.rekeningData.iban.toUpperCase().replace(/\s/g, '')
            == $parent.previousIntake.rekeningData.iban.toUpperCase().replace(/\s/g, '')
          ">
            We gaan aan de slag met uw wijzigingen en zullen deze aan u bevestigen. Het kan zijn dat
            we nog extra vragen hebben, dan nemen we contact met u op.
          </p>
          <p v-else-if="$parent.value == 0">
            Omdat u uw vaste tegenrekening heeft aangepast vragen wij u deze te bevestigen
            met een (iDeal) betaling van ten minste &euro; 0,01.
            <br /><br/>
            <depositWidget
              :iban="$parent.intake.rekeningData.iban"
              :identify="true"
              buttonType="button"
              buttonName="Identificatiestorting overmaken"
            />
          </p>
          <p v-else>
            We hebben de storting ontvangen, we gaan nu aan de slag met het doorvoeren
            van de wijzigingen. Het kan zijn dat we nog extra vragen hebben, dan
            nemen we contact met u op.
          </p>
        </template>
        <template v-else>
          <h2>
            1. Identificatie
          </h2>
          <h3>Storting</h3>
          <template v-if="
            $parent.value == 0
            && $parent.status == 'Ingeleverd'
            && (!$parent.intakeAdmin.cdd[`bankregistration`]
            || !$parent.intakeAdmin.cdd[`bankregistration`].answer)
          ">
            <p>
              U dient via onderstaande knop minimaal &euro; 0,01 ter identificatie over te
              maken.<br>
              Let op! Stortingen worden alleen geaccepteerd vanaf uw vaste tegenrekening ({{
                $parent.intake.rekeningData.iban.toUpperCase()
              }}).<br />
              <span v-if="$parent.intake.goalData.box !== '1'">
                U kunt wanneer u wenst ook direct het hele startbedrag overmaken.
              </span>
              <br /><br />
              <awesomeIcon icon="exclamation-circle" style="color:orange;" />
              U heeft nog geen geld overgemaakt ter identificatie.
            </p>
            <p v-if="$parent.intake.goalData.box != '1'">
              Startbedrag &euro; {{ formatPrice(Number($parent.value)) }} van de &euro;
              {{ formatPrice(Number($parent.intake.goalData.vermogen), true) }},-
            </p>
            <br />
            <depositWidget
              :iban="$parent.intake.rekeningData.iban"
              :identify="true"
              buttonType="button"
              buttonName="Identificatiestorting overmaken"
            />

          </template>
          <template v-else>
            <template
              v-if="$parent.intakeAdmin.cdd[`bankregistration`]
              && $parent.intakeAdmin.cdd[`bankregistration`].state !== 'none'
            ">
              <p v-if="
                $parent.intakeAdmin.cdd[`bankregistration`].answer === 'Match'
                || $parent.intakeAdmin.cdd[`bankregistration`].answer === 'Fysiek'
                || $parent.status !== 'Ingeleverd'
              ">
                <awesomeIcon icon="check" /> Identificatiestorting is akkoord.
              </p>
              <template v-else-if="
                $parent.intakeAdmin.cdd[
                  `bankregistration`
                ].answer === 'E/o niet leesbaar'"
              >
                <p>
                  <awesomeIcon icon="exclamation-circle" style="color:orange;"/>
                  De volledige tenaamstelling bij uw storting is niet leesbaar. Om beide en/of
                  tenaamstellingen te kunnen controleren, ontvangen wij graag een bankafschrift van
                  de en/of rekening.
                </p>
                <template>
                    <div class="subheader">
                      Upload hier een bankafschrift van de en/of rekening.
                    </div>
                    <div class="msg">
                    <ul style="padding-left:13px; margin:0px;">
                      <li>Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.</li>
                    </ul>
                    </div>
                    <customInput
                      type="file"
                      :prefix="`accountcopy`"
                      :validation="['files']"
                      :fromDate="new Date($parent.intakeAdmin.cdd[
                          `bankregistration`
                        ].date)"
                      :fileDelete="false"
                    />

                  </template>
              </template>
              <template v-else>
                <p v-if="$parent.intakeAdmin.cdd[`bankregistration`].answer === 'Geen match'">
                  <awesomeIcon icon="exclamation-circle" style="color:orange;"/>
                  Identificatiestorting is afgekeurd. Uw naam en/of uw IBAN nummer waarmee uw
                  gestort heeft komt niet overeen met uw Doelbeleggen rekening.
                  ({{$parent.intake.rekeningData.iban}}).
                  Stort opnieuw met de juiste naam en IBAN nummer als uw rekening bij
                  Doelbeleggen, of neem contact op om deze tegenrekening aan te passen.
                </p>
                <p v-else-if="$parent.intakeAdmin.cdd[`bankregistration`]
                  .answer === 'Geen Ned. Bank'
                ">
                  <awesomeIcon icon="exclamation-circle" style="color:orange;"/>
                  Identificatiestorting in behandeling. Omdat de identificatiestorting niet van een
                  Nederlandse bank afkomstig is, zijn er mogelijk extra controles nodig om de
                  identificatiestorting goed te keuren.
                </p>
                <p v-else>
                  <awesomeIcon icon="exclamation-circle" style="color:orange;"/>
                  Identificatiestorting is afgekeurd. Stort opnieuw van uw vaste tegenrekening
                  {{$parent.intake.rekeningData.iban}}.
                </p>
                <template v-if="$parent.intakeAdmin.cdd[`bankregistration`]
                  .answer !== 'Geen Ned. Bank'">
                  <p class="msg">
                    <b>Let op, </b>als u het geldbedrag al opnieuw heeft
                    overgemaakt, kunt u dit bericht negeren.
                  </p>
                  <depositWidget
                    :iban="$parent.intake.rekeningData.iban"
                    :identify="true"
                    buttonType="button"
                    buttonName="Geldbedrag overmaken"
                  />
                </template>
              </template>
            </template>
            <p v-else>
              <awesomeIcon icon="eye" style="color:orange;"/> Identificatiestorting in behandeling.
            </p>
          </template>
          <h3>Document</h3>
          <div v-for="(user, index) in $parent.intake.persoonsData" :key="`doc-${index}`">
            <template v-if="$parent.deathFilter(user)">
              <template v-if="$parent.intakeAdmin.cdd[`${index}-identification`]
                && $parent.intakeAdmin.cdd[`${index}-identification`].answer
              ">
                <p v-if="$parent.intakeAdmin.cdd[
                    `${index}-identification`
                  ].answer === 'Akkoord'"
                >
                  <awesomeIcon icon="check"/> Identificatie document van
                  <b>
                    {{user.voorletters}}
                    {{user.tussenvoegsel}}
                    {{user.achternaam}}
                  </b>  is akkoord.
                </p>
                <template v-if="$parent.intakeAdmin.cdd[
                    `${index}-identification`
                  ].answer !== 'Akkoord'"
                >
                  <p v-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Rijbewijs geüpload'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. Een rijbewijs is voor ons niet bruikbaar.
                  </p>
                  <p v-else-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Achterkant legitimatie mist'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. We missen de achterkant van het identificatie
                    document.
                  </p>
                  <p v-else-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Legitimatie ontbreekt'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. We missen een kopie van het identificatie
                    document.
                  </p>
                  <p v-else-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Slecht kopie legitimatie'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b>  is afgekeurd. De kopie is slecht leesbaar.
                  </p>
                  <p v-else-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Verlopen legitimatie'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. Het identificatie document is verlopen.
                  </p>
                  <p v-else-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer === 'Echtheidskenmerken niet correct'"
                  >
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. De echtheidskenmerken zijn niet correct.
                  </p>
                  <p v-else>
                    <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                    Identificatie document van
                    <b>
                      {{user.voorletters}}
                      {{user.tussenvoegsel}}
                      {{user.achternaam}}
                    </b> is afgekeurd. Wij nemen hierover contact met u op.
                  </p>
                  <template
                    v-if="$parent.intakeAdmin.cdd[
                      `${index}-identification`
                    ].answer !== 'Niet akkoord'"
                  >
                    <div class="subheader">
                      Upload hier een geldige kopie van het paspoort of ID-kaart van
                      <b>
                        {{user.voorletters}}
                        {{user.tussenvoegsel}}
                        {{user.achternaam}}
                      </b>
                    </div>
                    <div class="msg">
                    <ul style="padding-left:13px; margin:0px;">
                      <li>
                        <b><u>Let op, geen rijbewijs</u></b> en bij een identiteitskaart graag
                        voor- en achterkant (JPG, PNG, GIF en PDF).
                      </li>
                      <li style="cursor: pointer;" @click="infoModal = true">
                        Het kopie mag niet afgeschermd zijn, <u>meer informatie</u>.
                      </li>
                    </ul>
                    </div>

                    <customInput
                      type="file"
                      :prefix="`legitimatie${index}`"
                      :validation="['files']"
                      :fromDate="new Date($parent.intakeAdmin.cdd[
                        `${index}-identification`
                      ].date)"
                      :fileDelete="false"
                    />

                  </template>
                </template>
              </template>
              <p v-else>
                <awesomeIcon icon="eye" style="color:orange;"/> Identificatie document van
                <b>
                  {{user.voorletters}}
                  {{user.tussenvoegsel}}
                  {{user.achternaam}}
                </b> is in behandeling.
              </p>
            </template>
            <!-- Persoon overleden -->
            <p v-else>
              <awesomeIcon icon="eye" style="color:orange;"/> Identificatie document van
              <b>
                {{user.voorletters}}
                {{user.tussenvoegsel}}
                {{user.achternaam}}
              </b> is niet mogelijk.
            </p>
          </div>
          <h3>Woonadres</h3>
          <div
            v-for="(user, index) in filter(
              filter(
                filter(
                  $parent.intake.persoonsData,
                  o => o.zelfdeAdres !== 'Yes'),
                $parent.financeFilter),
              $parent.deathFilter,
              )
            "
            :key="`adr-${index}`"
          >
            <p
              v-if="(user.land === 'Nederland' && user.eigenwoning === 'Yes')
                || ($parent.intakeAdmin.cdd[`${index}-residentcertificate`]
                  && $parent.intakeAdmin.cdd[`${index}-residentcertificate`].answer
                  && ($parent.intakeAdmin.cdd[
                      `${index}-residentcertificate`
                    ].answer === 'Akkoord'
                    || $parent.intakeAdmin.cdd[
                      `${index}-residentcertificate`
                    ].answer === 'Akkoord, maar...'))
              "
            >
              <awesomeIcon icon="check"/> Controle woonadres van
              <b>
                {{user.voorletters}}
                {{user.tussenvoegsel}}
                {{user.achternaam}}
              </b>  is akkoord.
            </p>
            <template
              v-else-if="$parent.intakeAdmin.cdd[`${index}-residentcertificate`]
                && $parent.intakeAdmin.cdd[`${index}-residentcertificate`].answer
              "
            >
              <p>
                <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                Controle woonadres van
                <b>
                  {{user.voorletters}}
                  {{user.tussenvoegsel}}
                  {{user.achternaam}}
                </b>
                is afgekeurd. <br /><br />
                Graag ontvangen wij een kopie van een document met daarop uw naam
                en woonadres, bijvoorbeeld een energienota of bankafschrift.
              </p>
              <br />
              <div class="subheader">
                Upload hier een kopie van een document met daarop uw naam en woonadres van
                <b>
                  {{user.voorletters}}
                  {{user.tussenvoegsel}}
                  {{user.achternaam}}
                </b>
              </div>
              <div class="msg">
              <ul style="padding-left:13px; margin:0px;">
                <li>
                  Toegestane bestandsformaten zijn: JPG, PNG, GIF en PDF.
                </li>
                <li>
                  {{ index == 0 ? 'Uw ' : 'Deze persoon zijn '}}
                  document mag niet afgeschermd zijn.
                </li>
              </ul>
              </div>

              <customInput
                type="file"
                :prefix="`inschrijvingsbewijs${index}`"
                :validation="['files']"
                :fromDate="new Date($parent.intakeAdmin.cdd[
                  `${index}-residentcertificate`
                ].date)"
                :fileDelete="false"
              />
            </template>
            <p v-else>
              <awesomeIcon icon="eye" style="color:orange;"/> Controle woonadres van
              <b>
                {{user.voorletters}}
                {{user.tussenvoegsel}}
                {{user.achternaam}}
              </b> is in behandeling.
            </p>
          </div>
          <h2>
            2. Beleggingsrekening
          </h2>
          <p v-if="!$parent.port">
            <awesomeIcon icon="exclamation-circle" style="color:orange;" /> Uw
            beleggingsrekeningnummer is nog niet bekend.
          </p>
          <p v-else>
            <awesomeIcon icon="check" /> Uw beleggingsrekeningnummer is: {{$parent.port}}
          </p>
          <h2>
            3. Beleggingsplan
          </h2>
          <p v-if="$parent.status == 'Geaccepteerd'">
            Beleggingsplan is opgesteld.
            <br /><br />
            <awesomeIcon icon="exclamation-circle" style="color:orange;" /> U heeft nog geen akkoord
            gegeven op het plan.<br /><br />
            <button @click="planToggle = true">Beleggingsplan bekijken en accepteren</button>
          </p>
          <p v-else-if="$parent.status == 'Ondertekend'">
            <awesomeIcon icon="check" /> Beleggingsplan is ondertekend.<br /><br /><a
              @click="planToggle = true"
              >Bekijk nogmaals mijn beleggingsplan.</a
            >
          </p>
          <p v-else-if="$parent.value == 0">
            <awesomeIcon icon="exclamation-circle" style="color:orange;" /> Zodra uw identificatie
            is goedgekeurd, gaan we aan de slag met het opstellen van uw beleggingsplan.
          </p>
          <p v-else>
            <awesomeIcon icon="exclamation-circle" style="color:orange;" /> Nadat de identificatie
            goed is afgerond, gaan wij uw beleggingsplan voor u opstellen.
            <br /><br />U ontvangt per e-mail bericht van ons als alles in orde is en u verder kunt.
          </p>
          <template v-if="$parent.status != 'Ingeleverd'">
            <h2>
              4. Startbedrag
            </h2>

            <template v-if="$parent.intake.goalData.box !== '1'">
              <p v-if="Number($parent.value) >= Number($parent.intake.goalData.vermogen)">
                <awesomeIcon icon="check" /> Startbedrag is gestort.<br /><br />U heeft &euro;
                {{ formatPrice(Number($parent.value)) }} gestort, wilt u nog meer storten
                <depositWidget
                  :iban="$parent.intake.rekeningData.iban"
                  buttonType="link"
                  buttonName="klik dan hier."
                />
              </p>
              <template v-else>
                <p>
                  U kunt via onderstaande knop uw startbedrag overmaken.<br />
                  Let op! Dit kan alleen vanaf uw vaste tegenrekening ({{
                    $parent.intake.rekeningData.iban.toUpperCase()
                  }}).
                </p>
                <p>
                  <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                  U heeft nog niet uw volledige startbedrag overgemaakt.
                </p>
                <p>
                  Startbedrag &euro; {{ formatPrice(Number($parent.value)) }} van de &euro;
                  {{ formatPrice(Number($parent.intake.goalData.vermogen), true) }},-
                </p>
                <depositWidget
                  :iban="$parent.intake.rekeningData.iban"
                  buttonType="button"
                  buttonName="Geldbedrag overmaken"
                />
              </template>
            </template>
            <template v-else>
              <p>
                Hieronder vindt u een overzicht van uw opgegeven overdrachten. Afhankelijk van het
                type dient u een overdrachtsformulier te printen, ondertekenen en uploaden via
                ‘Upload formulier' of zelf een bedrag over te maken. Let daarbij op dat u het geld
                overmaakt van de aangegeven IBAN.
              </p>

              <!-- Overdrachtsformulier(en) -->
              <div style="overflow-x:auto;padding:0px;margin:0px;">
                <table width="100%">
                  <thead class="table-legend">
                    <tr>
                      <th width="20%">Type / Instelling</th>
                      <th width="20%">IBAN of Polis / Bedrag</th>
                      <th>Overdrachtsformulier / Overmaken</th>
                      <th>Ondertekend formulier</th>
                    </tr>
                  </thead>
                  <tr v-if="$parent.status !== 'Ondertekend'">
                    <td colspan="12" style="padding: 0px;">
                       <p class="msg">
                        Om uw, indien beschikbaar, overdrachtsformulier(en) te bekijken/printen,
                        dient u eerst bij punt 3 het beleggingsplan te accepteren.
                      </p>
                    </td>
                  </tr>
                  <tr
                    v-for="(overdracht, overdrachtIndex) in filter(
                      $parent.intake.transferData.overdrachten,
                      (o) => o.bedrag,
                    )"
                    :key='overdrachtIndex'
                  >
                    <td>
                      <span v-if="overdracht.overdrachtType === 'intern'">
                        Intern
                      </span>
                      <span v-else>
                        {{ overdracht.overdrachtType !== 'bv' ? 'PSK' : overdracht.kapitaalType}}
                      </span>
                      <br />
                      <span v-if="overdracht.overdrachtType === 'intern'" class="grey">
                        Doelbeleggen
                      </span>
                      <span v-else class="grey">
                        {{
                        overdracht.overdrachtType === 'psk'
                        ? `Polis: ${overdracht.instellingNaam}`
                        : overdracht.overdrachtType === 'bv'
                          ? `KVK: ${overdracht.instellingNaam}`
                          : `Rekening: ${overdracht.instellingNaam === 'Anders'
                          ? overdracht.instellingNaamOmschrijving
                          : overdracht.instellingNaam
                        }`
                      }}
                      </span>
                    </td>

                    <td>
                      <span>
                        {{overdracht.overdrachtType === 'psk' && overdracht.polisnummer
                          ? overdracht.polisnummer
                          : overdracht.iban
                        }}
                      </span>
                      <br />
                      <span class="grey">
                        &euro;&nbsp;{{ formatPrice(overdracht.bedrag, true)}}
                      </span>
                    </td>

                    <!-- Overdrachts formulier-->
                    <td>
                      <button
                        :class="{ 'disabled second': $parent.status !== 'Ondertekend' }"
                        style="width:200px; max-width:200px;"
                        v-if="overdracht.overdrachtType !== 'intern'
                          && (
                            overdracht.overdrachtType !== 'bv'
                            && overdracht.instellingNaam !== 'ASR'
                          )
                        "
                        :disabled="$parent.status !== 'Ondertekend'"
                        @click="loadPsk(overdracht)"
                      >
                        Print formulier <awesomeIcon icon="print"/>
                      </button>
                      <span
                        v-else-if="overdracht.instellingNaam === 'ASR'"
                        style="max-width: 75%;"
                      >
                        Bij ASR dient u zelf in het ASR klanten portaal een verzoek tot
                        overdracht van kapitaal in te dienen.
                      </span>
                      <span
                        v-else-if="overdracht.overdrachtType === 'intern'"
                        style="max-width: 75%;"
                      >
                        Doelbeleggen zal intern voor u de stukken overzetten naar uw nieuwe
                        rekening.
                      </span>
                      <depositWidget
                        v-else
                        :overdracht="true"
                        :iban="overdracht.iban"
                        buttonType="button"
                        buttonName="Geldbedrag overmaken"/>
                    </td>

                    <!-- upload -->
                    <td>
                      <customInput
                        v-if="overdracht.overdrachtType !== 'intern'
                          && overdracht.overdrachtType !== 'bv'
                          && overdracht.instellingNaam !== 'ASR'
                          && $parent.status == 'Ondertekend'
                        "
                        type="file"
                        :showHoverInfo="true"
                        :fileDelete="false"
                        label="Upload formulier"
                        :prefix="`overdrachten-${Number(overdracht.index)}-ondertekend`"
                        :validation="['files']"
                      />
                    </td>

                  </tr>
                  <tr v-if="!($parent.intake.goalData.type === 'levensonderhoud'
                    || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
                    || $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
                    || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend')
                    && Number($parent.intake.goalData.vermogen)
                        - Number(sumBy(
                        filter($parent.intake.transferData.overdrachten, 'bedrag'),
                        o => Number(o.bedrag),
                    )) > 0"
                  >
                    <td> jaar/reserveringsruimte <br /> <span class="grey">zelf</span></td>
                    <td>
                      {{$parent.intake.rekeningData.iban.toUpperCase().replace(/\s/g, '')}} <br />
                      <span class="grey">
                        &euro;&nbsp;{{
                          formatPrice(
                          Number($parent.intake.goalData.vermogen)
                          - Number(sumBy(
                            filter($parent.intake.transferData.overdrachten, 'bedrag'),
                            o => Number(o.bedrag),
                          )), true)
                        }}
                      </span>
                    </td>
                    <td>
                      <depositWidget
                        :iban="$parent.intake.rekeningData.iban"
                        buttonType="button"
                        buttonName="Geldbedrag overmaken"/>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </template>
            <template v-if="$parent.status == 'Ondertekend'">
              <h2>
                5. Beleggen
              </h2>
              <p
                v-if="
                  $parent.status == 'Ondertekend' &&
                    Number($parent.value) >= Number($parent.intake.goalData.vermogen)
                "
              >
                <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                Wij zijn bezig met het aankopen van uw posities.<br /><br />
                U ontvangt per e-mail bericht van ons wanneer u uw portefeuille kan inzien.
              </p>
              <p v-else>
                <awesomeIcon icon="exclamation-circle" style="color:orange;" />
                Posities worden aangekocht nadat uw startbedrag of bijstortingen op uw
                beleggingsrekening zijn bijgeschreven.
              </p>
            </template>
            <template v-else>
              <h2 style="color: grey">
                5. Beleggen
              </h2>
            </template>
          </template>
          <template v-else>
            <h2 style="color: grey">
              4. Startbedrag
            </h2>
            <h2 style="color: grey">
              5. Beleggen
            </h2>
          </template>
        </template>
      </div>
      <div class="content inset" v-else>
        <button
          class="secondary setting"
          @click="$parent.returnIntake"
          v-if="$parent.status == 'Ingeleverd' && $parent.role > 7"
        >
          <awesomeIcon icon="edit" /> Heropenen (admin)
        </button>
        <button
          class="secondary setting"
          @click="$parent.overviewToggle = true"
          v-if="$parent.role > 7"
        >
          <awesomeIcon icon="sign-out-alt" /> Overzicht bekijken (admin)
        </button>
        <h2 class="title">
          <awesomeIcon icon="lock" />
          {{ $parent.redo ? 'Vragenlijst ontvangen' : 'Rekening geopend'}}
        </h2>
        <h2>Uw gegevens worden verwerkt</h2>
        <p style="line-height: 150%;">
          Het kan zijn dat wij nog vragen hebben. Wij zullen hierover contact met u opnemen.
          Het kan natuurlijk ook zijn dat u nog vragen heeft, neem daarvoor contact op met uw
          vermogensbeheerder of een collega.
        </p>
      </div>
    </div>

    <!-- plan -->
    <modalWindow v-show="planToggle" @close="planToggle = false" width="860" position="edge">
      <div v-if="!$parent.signing">
        <div class="titlebar">Beleggingsplan</div>
        <div class="viewport">
          <plan
            v-if="$parent.intakeAdmin.beleggen.brand != 'Doelbeleggen'"
            style="padding:20px; width:800px; overflow:auto;"
            :intake="intake"
            :redo="$parent.redo"
            :portValue="$parent.portValue"
            :intakeAdmin="intakeAdmin"
            :today="new Date()"
          />
          <planDB
            v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
            style="padding:20px; width:800px; overflow:auto;"
            :intake="intake"
            :intakeAdmin="intakeAdmin"
            :id="$parent.id"
            :redo="$parent.redo"
            :portValue="$parent.portValue"
            :today="new Date()"
          />
        </div>
        <div class="modalfooter" v-if="$parent.status == 'Geaccepteerd'">
          <button style="float:right;" @click="$parent.signIntake()">
            Accepteer beleggingsplan <awesomeIcon icon="check" />
          </button>
        </div>
      </div>
      <div v-else class="loader" />
    </modalWindow>

    <div class="card">
    <!-- psk form -->
      <modalWindow
        v-show="pskFormToggle"
        @close="pskFormToggle = false; selectedPsk = {};"
        width="860"
        position="edge"
      >
        <div class="titlebar">Overdrachtsformulier</div>
        <div class="viewport">
          <pskForm
            :currentPsk="selectedPsk"
            :intake="$parent.intake"
            :email="$parent.email"
            :id="$parent.id"
            :port="$parent.port"
          />
        </div>
        <div class="modalfooter">
          <span
            v-if="
              `${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1
            "
          >
            Printen is alleen mogelijk vanuit de site
          </span>
          <button style="float:right;" @click="windowPrint" v-else>
            Printen <awesomeIcon icon="print" />
          </button>
        </div>
      </modalWindow>
      <!-- Identification info -->
      <modalWindow v-show="infoModal" @close="infoModal = false" width="400">
        <div class="titlebar">Paspoort / Identiteitskaart</div>
        <div class="inset">
          Wij zijn verplicht om de identiteit van onze klanten vast te stellen door de wettelijke
          verplichtingen ter voorkoming van witwassen en terrorismefinanciering (Wwft). Ook zijn wij
          door de belastingdienst verplicht uw BSN te verwerken.
          <img src="../../assets/img/pass3.jpg"
            style="width:100%; margin:10px auto; display:block;"
          />
          <ul style="padding-left:13px;">
            <li>Achternaam</li>
            <li>Voornaam en voorletters</li>
            <li>Geboortedatum</li>
            <li>Documentnummer</li>
            <li>Geldigheidsdatum</li>
            <li>Geboorteplaats (bij ID-kaart op achterkant)</li>
            <li>Nationaliteit</li>
            <li>Burgerservicenummer (bij ID-kaart op achterkant)</li>
          </ul>
          Soms wordt het burgerservicenummer op een aparte pagina in uw paspoort vermeld.
          Maakt u in dat geval dan ook een kopie van deze pagina.
        </div>
      </modalWindow>
      <modalWindow v-if="transaction" @close="clearIdeal">
        <div class="titlebar">Controleren van storting</div>
        <div class="inset">
          {{idealMessage}}
          <button @click="clearIdeal">OK</button>
        </div>
      </modalWindow>
    </div>
  </div>
</template>

<script>
import { filter, sumBy } from 'lodash-es';
import depositWidget from './deposit';
import plan from './plan';
import planDB from './planDB';
import pskForm from './pskForm';

export default {
  name: 'IntakeStatusPage',
  emits: ['update:model-value'],
  components: {
    depositWidget,
    plan,
    planDB,
    pskForm,
  },
  data() {
    return {
      modal: false,
      infoModal: false,
      planToggle: false,
      selectedPsk: {},
      pskFormToggle: false,
      idealMessage: 'We zijn uw storting aan het controleren...',
      location: window.location,
    };
  },
  props: {
    modelValue: Object,
  },
  computed: {
    transaction() {
      return this.$parent.$parent.transaction;
    },
    value() {
      return this.modelValue;
    },
    intake() {
      return this.$parent.intake;
    },
    intakeAdmin() {
      return this.$parent.intakeAdmin;
    },
    ibans() {
      const ibanArray = [];
      const overdrachtenArray = filter(
        this.$parent.intake.transferData.overdrachten,
        (o) => o.bedrag && o.iban,
      );
      for (let i = 0; i < overdrachtenArray.length; i += 1) {
        ibanArray.push(`${overdrachtenArray[i].iban}`.toUpperCase().replace(/\s/g, ''));
      }
      ibanArray.push(`${
        this.$parent.intake.rekeningData.iban
      }`.toUpperCase().replace(/\s/g, ''));
      return ibanArray;
    },
  },
  created() {
    if (this.transaction) {
      this.sdk.checkIntakeIdeal(this.getQueryVariable('intake'), this.transaction, (response) => {
        if (response.status === 200 && response.data.status !== 0) {
          if (this.ibans.indexOf(`${response.data.iban}`.toUpperCase().replace(/\s/g, '')) !== -1) {
            this.idealMessage = 'We hebben uw storting ontvangen.';
          } else {
            this.idealMessage = 'We hebben uw storting ontvangen maar het komt van een verkeerde tegenrekening. Heeft u uw tegenrekening op het begin foutief opgegeven neem dan contact op. Zo niet maak dan van de juiste tegenrekening uw storting over. Stortingen van onbekende tegenrekeningen worden teruggeboekt.';
          }
        } else {
          this.idealMessage = 'Het lijkt er op dat er iets mis is gegaan tijdens het betaalproces. Druk op ok en probeer opnieuw. Neem gerust contact met ons op als u vragen heeft.';
        }
      });
    }
  },
  watch: {
    planToggle() {
      if (this.planToggle === true) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'initial';
      }
    },
  },
  methods: {
    filter,
    sumBy,
    clearIdeal() {
      window.onbeforeunload = () => {};
      window.location.href = `?intake=${this.getQueryVariable('intake')}`;
    },
    loadPsk(overdracht) {
      this.selectedPsk = {};
      this.selectedPsk = overdracht;
      this.pskFormToggle = true;
    },
    readableTransferName(name) {
      let readableName;
      if (name === 'psk') {
        readableName = 'vanuit PSK';
      }
      if (name === 'psk2') {
        readableName = 'vanuit overige';
      }
      return readableName;
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  cursor: pointer;
}
h2 {
  margin-top: 30px;
  &:first-child {
    margin-top: 0;
  }
}
p {
  svg {
    color: $color-highlight;
  }
}
button.second {
  color: rgba(#000, 0.8);
  background-color: $color-grey-dark;
  &:hover {
    background-color: darken($color-grey-dark, 5%);
  }
}
table {
  border: 1px solid #ccc;
  margin-top: 30px;
  tr {
    background-color: #fdfdfd;
  }
  &:first-child {
    margin-top: 0;
  }
}
.tablehead {
  background-color: #eee;
}
.divider-box {
  background-color: #fdfdfd;
  padding: 20px;
  margin: 20px 0;
}
</style>
